import $ from 'jquery';
import { disableElement } from '../utils/input';
const ELEMENT_SELECTOR = '.js__initial-order-search';
const SEARCH_BUTTON_TEXT = '<i class="search icon"></i>';
const SEARCH_BUTTON = `<button type="button" class="ui icon button">${SEARCH_BUTTON_TEXT}</button>`;
const MODAL_BUTTON = `<button type="button" class="ui button primary js__ajax-modal-btn" data-url="%url%">%text%</button>`;
const BUTTON_LOADER = '<div class="ui active tiny inline loader"></div>';
const ERROR_MESSAGE_SELECTOR = '.ui.red.pointing.label';
const ADD_PRODUCT_SELECTOR = '.js__add-button';
const REMOVE_PRODUCT_SELECTOR = '.js__remove-button';
const PRODUCT_TYPE_INPUT_SELECTOR = '.js__product-type';
const PRODUCT_RETURN_INPUT_SELECTOR = '.js__product-return';
const DEVICE_RETURN_INPUT_SELECTOR = '.js__device-return';
const DEVICE_RETURN_SELECT_BUTTON_SELECTOR = '.js__device-return-select-button';
const PRODUCT_RETURN_SELECT_BUTTON_SELECTOR = '.js__product-return-select-button';
const RETURN_ORDER_CATEGORY_INPUT_SELECTOR = '.js__return-order-category';
const COLLECTION_ITEMS_SELECTOR = '.js__collection-items';
const DEVICE_RETURN_MONEY_AMOUNT_SELECTOR = '.js__item-money-return-amount';
const TOTAL_RETURN_MONEY_AMOUNT_SELECTOR = '.js__money-return-amount';
const PROTOTYPE_CONTAINER_SELECTOR = '.js__prototype-container';
var ReturnOrderType;
(function (ReturnOrderType) {
    ReturnOrderType["Regular"] = "regular";
    ReturnOrderType["MoneyBack"] = "money-back";
})(ReturnOrderType || (ReturnOrderType = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["Other"] = "other";
    DeviceType["Device"] = "device";
})(DeviceType || (DeviceType = {}));
export class InitialOrderSearch {
    static xhrRequest = null;
    static previousInputValue = $(ELEMENT_SELECTOR).val();
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        if (!$elements.length) {
            return;
        }
        this.initActions($elements);
    }
    static initActions($elements) {
        $elements.each((index, element) => {
            const $element = $(element);
            const $searchButton = $(SEARCH_BUTTON);
            const modalUrl = $elements.data('modal-button-url');
            const modalButtonHtml = MODAL_BUTTON.replace('%url%', modalUrl).replace('%text%', $elements.data('modal-button-text'));
            const $secondSearchButton = $(modalButtonHtml);
            $element.wrap('<div class="ui action input"></div>');
            $element.parent().append($searchButton);
            if (modalUrl) {
                $element.parent().append($secondSearchButton);
            }
            $searchButton.on('click', e => {
                this.handleSearch($element, $searchButton);
            });
            $element.on('keypress', e => {
                if (e.which === 13) {
                    e.preventDefault();
                    $element.trigger('blur');
                }
            });
            $element.on('change', e => {
                const value = $(e.currentTarget).val();
                if (this.previousInputValue !== value) {
                    this.previousInputValue = String(value);
                    this.removeAllSelectedProducts();
                    this.handleSearch($element, $searchButton);
                }
            });
            $('body').on('change', DEVICE_RETURN_INPUT_SELECTOR, e => {
                const $element = $(e.currentTarget);
                this.updateInputsOnDeviceChange($element);
            });
            $(ADD_PRODUCT_SELECTOR).on('click', e => {
                const $element = $(e.currentTarget);
                const $returnProductInput = $(PRODUCT_RETURN_INPUT_SELECTOR).last();
                $returnProductInput.dropdown({
                    onChange: () => {
                        this.updateInputsOnDeviceChange($returnProductInput);
                    },
                });
            });
            $('body').on('change keyup', DEVICE_RETURN_MONEY_AMOUNT_SELECTOR, e => {
                this.calculateTotalReturnMoneyAmount();
            });
            if ($element.val()) {
                this.handleSearch($element, $searchButton, true);
            }
        });
        $('body').on('click', REMOVE_PRODUCT_SELECTOR, () => {
            this.calculateTotalReturnMoneyAmount();
        });
        if (!$(TOTAL_RETURN_MONEY_AMOUNT_SELECTOR).val()) {
            this.calculateTotalReturnMoneyAmount();
        }
    }
    static handleSearch($input, $button, isInitialSearch = false) {
        if (this.xhrRequest) {
            this.xhrRequest.abort();
            this.xhrRequest = null;
        }
        if (!$input.val()) {
            return;
        }
        this.xhrRequest = $.ajax({
            method: 'GET',
            url: $input.data('search-url').replace('input_value', $input.val()),
            beforeSend: () => {
                $button.html(BUTTON_LOADER);
                this.removeErrorMessages($input);
                this.removeMessages($input);
            },
        })
            .done((data) => {
            const parameterKeyToMatch = String($input.data('parameter-key-to-match'));
            const customerId = $input.data('customer-id');
            if (data.product && !isInitialSearch) {
                $(ADD_PRODUCT_SELECTOR).trigger('click');
                $(PRODUCT_TYPE_INPUT_SELECTOR)
                    .find(`[value=${data.product.device_type}]`)
                    .prop('checked', true)
                    .trigger('change');
                if (data.product.device_type === DeviceType.Other) {
                    $(PRODUCT_RETURN_INPUT_SELECTOR).data('price', data.total / 100);
                    $(PRODUCT_RETURN_INPUT_SELECTOR).dropdown('set selected', data.product.variant_id).trigger('change');
                }
                else if (data.product.codentify && data.product.device_id) {
                    $(DEVICE_RETURN_INPUT_SELECTOR).on('loaded', (e, loadedData) => {
                        if (loadedData.results.length === 1) {
                            $(e.currentTarget).dropdown('set selected', data.product.device_id).trigger('change');
                        }
                    });
                    $(DEVICE_RETURN_INPUT_SELECTOR).data('price', data.total / 100);
                    $(DEVICE_RETURN_INPUT_SELECTOR)
                        .find('.js__init-search-dropdown')
                        .val(data.product.codentify)
                        .trigger('keyup');
                    const $returnOrderCategoryInput = $(RETURN_ORDER_CATEGORY_INPUT_SELECTOR);
                    if (customerId) {
                        $returnOrderCategoryInput
                            .dropdown('set selected', $returnOrderCategoryInput.find('select').data('default-value'))
                            .trigger('change');
                    }
                    else {
                        $returnOrderCategoryInput.dropdown('set selected', ReturnOrderType.Regular).trigger('change');
                    }
                }
            }
            if (data.state != 'completed') {
                this.showErrorMessage($input, $input.data('search-not-completed-text').replace('link_parameter', data[$input.data('link-parameter-key')]));
                disableElement($($input.data('hide-field-on-not-found')), true, '', false, true);
                $($input.data('set-input-value-on-success')).data('initial-value', '');
            }
            else {
                const isCustomersDiffer = parameterKeyToMatch && data[parameterKeyToMatch] && customerId != data[parameterKeyToMatch];
                const customerDiffersText = $input
                    .data('parameter-not-match-text')
                    .replace('link_parameter', data[$input.data('link-parameter-key')]);
                const customerMatchText = $input
                    .data('search-found-text')
                    .replace('link_parameter', data[$input.data('link-parameter-key')]);
                this.showMessage($input, isCustomersDiffer ? customerDiffersText : customerMatchText, isCustomersDiffer ? 'yellow' : 'info');
                disableElement($($input.data('hide-field-on-not-found')), true, '', false, true);
                const total = (Number(data[$input.data('set-input-value-from-data-key')]) / 100).toFixed(2);
                const $inputToSetOnSuccess = $($input.data('set-input-value-on-success'));
                $($input.data('set-input-value-on-success')).data('initial-value', total);
                if (isInitialSearch) {
                    $($inputToSetOnSuccess).trigger('change');
                }
                else {
                    if (!$($inputToSetOnSuccess).prop('disabled')) {
                        $($inputToSetOnSuccess).val(total);
                    }
                }
                $($input.data('unset-checkbox-on-success')).prop('checked', false);
                const isResellerOrder = data.shipping_method === 'reseller';
                const $orderTypeInput = $($input.data('return-order-type'));
                $orderTypeInput.find('input[value="r08"]').prop('checked', !isResellerOrder);
                $orderTypeInput.find('input[value="r09"]').prop('checked', isResellerOrder);
            }
            this.updateDeviceSelectModalUrl(data, customerId);
            this.updateProductSelectModalUrl(data);
        })
            .fail(xhr => {
            if (xhr.status === 404) {
                this.showErrorMessage($input, $input.data('search-not-found-text'));
            }
            disableElement($($input.data('hide-field-on-not-found')), true, '', false, true);
        })
            .always(() => {
            $button.html(SEARCH_BUTTON_TEXT);
        });
    }
    static updateProductSelectModalUrl(data) {
        setTimeout(() => {
            const $returnSelectProductBtn = $(PRODUCT_RETURN_SELECT_BUTTON_SELECTOR);
            const orderUrl = $returnSelectProductBtn.data('order-url');
            $returnSelectProductBtn.each((index, element) => {
                if (data.state === 'completed') {
                    $(element).data('url', orderUrl.replace('%25orderId%25', data.id));
                }
            });
        }, 500);
        const $collectionItem = $(ADD_PRODUCT_SELECTOR).closest(COLLECTION_ITEMS_SELECTOR);
        const $prototype = $('<div></div>').append($($collectionItem.data('prototype')));
        const $returnSelectProductBtn = $prototype.find(PRODUCT_RETURN_SELECT_BUTTON_SELECTOR);
        const orderUrl = $returnSelectProductBtn.data('order-url');
        if (data.state === 'completed') {
            $returnSelectProductBtn.attr('data-url', orderUrl.replace('%25orderId%25', data.id));
        }
        $collectionItem.data('prototype', $prototype.prop('outerHTML'));
    }
    static updateDeviceSelectModalUrl(data, customerId) {
        setTimeout(() => {
            const $returnSelectDeviceBtn = $(DEVICE_RETURN_SELECT_BUTTON_SELECTOR);
            const customerUrl = $returnSelectDeviceBtn.data('customer-url');
            const orderUrl = $returnSelectDeviceBtn.data('order-url');
            $returnSelectDeviceBtn.each((index, element) => {
                if (data.state === 'completed') {
                    $(element).data('url', orderUrl.replace('%25orderId%25', data.id));
                }
                else if (customerId) {
                    $(element).data('url', customerUrl.replace('%25customerId%25', customerId));
                }
            });
        }, 500);
        const $collectionItem = $(ADD_PRODUCT_SELECTOR).closest(COLLECTION_ITEMS_SELECTOR);
        const $prototype = $('<div></div>').append($($collectionItem.data('prototype')));
        const $returnSelectDeviceBtn = $prototype.find(DEVICE_RETURN_SELECT_BUTTON_SELECTOR);
        const customerUrl = $returnSelectDeviceBtn.data('customer-url');
        const orderUrl = $returnSelectDeviceBtn.data('order-url');
        if (data.state === 'completed') {
            $returnSelectDeviceBtn.attr('data-url', orderUrl.replace('%25orderId%25', data.id));
        }
        else if (customerId) {
            $returnSelectDeviceBtn.attr('data-url', customerUrl.replace('%25customerId%25', customerId));
        }
        $collectionItem.data('prototype', $prototype.prop('outerHTML'));
    }
    static removeAllSelectedProducts() {
        const $deviceValueInput = $('.js__set-device-value');
        const $deleteButton = $deviceValueInput.first().closest(COLLECTION_ITEMS_SELECTOR).find(REMOVE_PRODUCT_SELECTOR);
        $deviceValueInput.each((index, element) => {
            $deleteButton.trigger('click');
        });
    }
    static removeErrorMessages($input) {
        $input.parent().parent().find(ERROR_MESSAGE_SELECTOR).remove();
        $input.closest('.field').removeClass('error');
    }
    static removeMessages($input) {
        $input.parent().parent().parent().find('.js__input-with-search-message').remove();
    }
    static showErrorMessage($input, message) {
        $input.parent().parent().append(`<div class="ui red pointing label">${message}</div>`);
        $input.closest('.field').addClass('error');
    }
    static showMessage($input, message, messageColor) {
        const $message = $(`<div class="ui ${messageColor} message js__input-with-search-message">${message}</div>`);
        $message.insertAfter($input.parent().parent());
    }
    static calculateTotalReturnMoneyAmount() {
        const $moneyReturnAmountInput = $(TOTAL_RETURN_MONEY_AMOUNT_SELECTOR);
        const $itemMoneyReturnAmountInput = $(DEVICE_RETURN_MONEY_AMOUNT_SELECTOR);
        let sum = 0;
        $itemMoneyReturnAmountInput.each((index, element) => {
            const $element = $(element);
            sum = sum + Number($element.val() || 0);
        });
        $moneyReturnAmountInput.val(sum.toFixed(2));
    }
    static updateInputsOnDeviceChange($element) {
        const $closestReturnCategoryInput = $element
            .closest(PROTOTYPE_CONTAINER_SELECTOR)
            .find(RETURN_ORDER_CATEGORY_INPUT_SELECTOR);
        const $closestReturnMoneyAmountInput = $element
            .closest(PROTOTYPE_CONTAINER_SELECTOR)
            .find(DEVICE_RETURN_MONEY_AMOUNT_SELECTOR);
        const price = $element.data('price') || $element.parent().data('price');
        if (price) {
            $closestReturnMoneyAmountInput.val(Number(price || 0).toFixed(2)).trigger('change');
        }
        const defaultReturnCategoryValue = $closestReturnCategoryInput.find('select').data('default-value');
        $closestReturnCategoryInput.dropdown('set selected', defaultReturnCategoryValue).trigger('change');
    }
}
